import ApiBase from '../../../ApiBase';

class Element extends ApiBase {
    route = '/admin/cms/elements/elements';
}

export default new Element();
